export const FETCH_UPDATE_THERMIT_UNIT_MIN_MAX_REQUEST = 'FETCH_UPDATE_THERMIT_UNIT_MIN_MAX_REQUEST'
export const FETCH_UPDATE_THERMIT_UNIT_MIN_MAX_SUCCESS = 'FETCH_UPDATE_THERMIT_UNIT_MIN_MAX_SUCCESS'
export const FETCH_UPDATE_THERMIT_UNIT_MIN_MAX_FALUIRE = 'FETCH_UPDATE_THERMIT_UNIT_MIN_MAX_FALUIRE'
